module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAAXNSR0IArs4c6QAAASFJREFUGBnNwb1LlAEAB+Bf0OBQEQp9iItkkA3iLQ0nGW25SkQQBFFbtmQ23dA/cEtINQWNSdgfYBBBqxxOLxWBB31QfiyCRYZPL4f0Wpxj0PPkP2HYbdcsWzHjuivZi7YXtlw0at1rH51Ld1bUHE7JIT0+q6U7DYvG1NXV3fcqe3HTlkKhUFj2xul0o6ntTH5z16rR/M209wYSC8bsM+tqYsoHvdnNkA0jKbls3bwlfSl56kF2M+thSno0FZgzmZITNh1MxTvjKdnvjsc+aTifDi0TqfiuPyUHtLR9U2ikw7wbqfhiKB1qbnmr7lg6vHQpFc/cyw4jnmeHUzYdT8WwVY9ccNJRfXodMeishq9m8if9mhat+WEbP61peWI8/8wvgurVucuTrsQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_record_s.png
// module id = tng8
// module chunks = 1